import { AuthenticationError } from './authentication-error';

export const toAuthenticationError = (error: any, message: string): AuthenticationError => ({
    name: error.name,
    message: error.message,
    customMessage: message,
});
